Wee.fn.make('navigation', {
	init: function() {
		$('ref:hasDropdown').on('click', function(e, el) {
			$(el).next('ref:dropdown').toggleActive();
		});
	}
});